import React, { useEffect, useState } from 'react';

import RankabilityDarkLogo from './RankabilityDarkLogo';
import RankabilityLightLogo from './RankabilityLightLogo';
import { ContentOptimizerQueueStatus } from '../../../constants/contentOptimizer';

const RankabilityLoaderLogo = ({ optimizerStatus, darkMode }) => {
    const [completedLogo, setCompletedLogo] = useState(0);

    useEffect(() => {
        if (optimizerStatus !== ContentOptimizerQueueStatus.QUEUED) {
            const timeout = setTimeout(
                () => setCompletedLogo(completedLogo < 100 ? completedLogo + 6 : 4),
                100
            );

            return () => clearTimeout(timeout);
        }
    }, [completedLogo, optimizerStatus]);

    const getProgress = (progress) => {
        return optimizerStatus !== ContentOptimizerQueueStatus.QUEUED ? progress : 0;
    };

    return darkMode ? (
        <RankabilityDarkLogo progress={getProgress(completedLogo)} />
    ) : (
        <RankabilityLightLogo progress={getProgress(completedLogo)} />
    );
};

export default RankabilityLoaderLogo;
